import React from "react";
import { MessageCircle } from "lucide-react";

// Thin wrapper so all chat triggers share the `chat js-chat` classes
// (consumed by the global chat-script.js to open LiveChat).
export const ChatButton = ({ className = "", children, ...rest }) => (
  <button
    type="button"
    className={`chat js-chat inline-flex items-center gap-2 ${className}`}
    data-testid="chat-button"
    {...rest}
  >
    {children || (
      <>
        <MessageCircle className="h-4 w-4" /> Chat Now
      </>
    )}
  </button>
);

export default ChatButton;
